import { useParams } from "react-router";
import FileManager from "components/file-manager/file-manager";

export default function InvestorUpdates() {
    const params = useParams();

    return (<>
        <FileManager 
            includeCaseName={false} 
            caseSlug={params.slug}
        />
    </>);
}